import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.56);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

export const Container = styled.div`
  min-width: 440px;
  background: ${({ theme }) => theme.colors.gray900};
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media ${({ theme }) => theme.breakpoints.tablet} {
    position: fixed;
    bottom: 0;
    min-width: auto;
    width: 100%;
    border-radius: 16px 16px 0 0;
  }
`;

export const Content = styled.div`
  margin: 24px 24px 0 24px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Title = styled.label`
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  margin-top: 3px;
  color: ${({ theme }) => theme.colors.green500};
`;

export const CloseButton = styled.button`
  font-size: 10px;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.gray950};
  border: none;

  :before {
    color: ${({ theme }) => theme.colors.gray0};
    font-size: 17px;
  }
`;

export const Footer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  padding: 24px 0;
`;
